export default {
  methods: {
    back () {
      this.$Progress.finish()
      this.$router.back()
    }
  }
}
